export function extractFirstName (name) {
  let index = name.trim().indexOf(' ')
  return index > 0 ? name.substring(0, index) : name
}



// WEBPACK FOOTER //
// ./src/utils/extractFirstName.js